<template>
  <div id="energy" class="h100" />
</template>

<script>
import * as echarts from "echarts";
import { getLang } from "@/utils/auth";

export default {
  name: "EnergyTrend",
  props: {
    propData: {
      type: Object,
      default: () => ({
        xAxisData: [],
        seriesData: []
      })
    }
  },
  data() {
    return {
      energyChart: null
    };
  },
  computed: {
    isZh() {
      return getLang("lang") === "zh";
    }
  },
  mounted() {
    this.initEnergy();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.energyChart.resize);
  },
  methods: {
    initEnergy() {
      this.$nextTick(() => {
        this.energyChart = echarts.init(document.getElementById("energy"));
        this.energyChart.setOption({
          color: ["#00B259"],
          tooltip: {
            trigger: "axis",
            padding: 0,
            borderWidth: 0,
            axisPointer: {
              type: "none"
            },
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            formatter: params => `<div class="energy-tooltip-content">
                 <div class="energy-tooltip-title">
                   <div class="energy-tooltip-tip" style="background: ${params[0].color}"></div>
                   <span style="margin-right: 10px;">${params[0].axisValue}</span>
                   <span>${params[0].value}</span>
                 </div>
              </div>`
          },
          legend: {
            show: false
          },
          grid: {
            top: 20,
            left: 5,
            right: this.isZh ? 60 : 120,
            bottom: 6,
            containLabel: false
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              name: this.$t("home.monthlyTrend"),
              nameTextStyle: {
                color: "#505363",
                fontSize: 14
              },
              axisLabel: {
                textStyle: {
                  color: "#00B259"
                }
              },
              axisLine: {
                lineStyle: {
                  color: "#00B259"
                }
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              data: this.propData.xAxisData,
              triggerEvent: true
            }
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                textStyle: {
                  color: "#00B259"
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: "能源消耗",
              type: "line",
              symbol: "circle",
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                width: 0
              },
              areaStyle: {
                normal: {
                  color: "#00B259"
                }
              },
              smooth: true,
              data: this.propData.seriesData
            }
          ]
        });
        window.addEventListener("resize", this.energyChart.resize);
      });
    }
  }
};
</script>

<style>
.energy-tooltip-content {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  padding: 8px 20px 8px 24px;
  min-width: 100px;
}
.energy-tooltip-title {
  position: relative;
  margin-bottom: 2px;
}
.energy-tooltip-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 6px;
  left: -12px;
}
</style>
